import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import {updateUserMessage, getUserMessage} from '../../../actions/user-api';
import { useDispatch, useSelector } from 'react-redux';

export const Message = () => {
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const [message, setMessage] = useState(user.message);
    const [wasValidated, setWasValidated] = useState(false);
    const messageRef = useRef(null);

    const hideModal = () => {
        $('.modal').modal("hide");
    };
    useEffect(() => {
        dispatch(getUserMessage());
    }, []);

    useEffect(() => {
        if (user.message === message || user.message === undefined) {
            setWasValidated(false);
            hideModal();
        }
        else if (message === '' && user.message !== '') {
            setMessage(user.message);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.message]);

    return (
        <div className="modal fade px-0" id="messageEdit" aria-labelledby="messageEditLabel" aria-hidden="true">
			<div className="modal-dialog px-2 container-default">
				<div className="modal-content">
					<div className="modal-header" data-dismiss="modal" aria-label="Close" onClick={()=>{setWasValidated(false);}}>
						<div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
                            <h5 className="sr-only visually-hidden">Mandataire message</h5>
							<div className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1" id="infoValiderLabel">message à votre mandataire</div>
						</div>
					</div>
					<div className="modal-body scroll-default py-0">
						<form className="block" ref={messageRef} noValidate>
							<p className="h6 font-weight-bold">Ce message ne sera visible par votre ou vos réferent(s) qu'aprés votre décès.</p>
							<div className="form-group bg-light rounded p-4">
                                <textarea required={true} className="form-sign rounded form-control border-none bg-none text-dim--placeholder" placeholder="Ecrivez ici votre message..." defaultValue={message} onChange={(e) => {
                                    e.preventDefault();
                                    setMessage(e.target.value);
                                }}></textarea>
                                <div className={"invalid-feedback alert-danger alert" + (wasValidated === true ? ' d-block' : '')}>
                                    Veuillez écrire un message
                                </div>
                            </div>
                        </form>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-light mr-2" data-dismiss="modal" onClick={()=>{ setWasValidated(false);}}>Fermer</button>
						<button className="btn btn-info" onClick={(event) => {
                                event.preventDefault();
                                if (messageRef.current.checkValidity()) {
                                    dispatch(updateUserMessage(message));
                                }
                                messageRef.current.classList.add('was-validated');
                                setWasValidated(true);
                            }}>Sauvegarder</button>
					</div>
				</div>
			</div>
		</div>
    );
}